import { render, staticRenderFns } from "./version.vue?vue&type=template&id=ae1e3660&scoped=true"
import script from "./version.vue?vue&type=script&lang=ts"
export * from "./version.vue?vue&type=script&lang=ts"
import style0 from "./version.vue?vue&type=style&index=0&id=ae1e3660&prod&lang=stylus&scoped=true"
import style1 from "./version.vue?vue&type=style&index=1&id=ae1e3660&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ae1e3660",
  null
  
)

export default component.exports